import {Component, OnInit, OnDestroy, AfterViewChecked, HostListener, Renderer2} from '@angular/core';
import { Router, ActivatedRoute, ActivationStart } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable'
import * as moment from 'moment';
import * as numeral from 'numeral/numeral';
import 'numeral/locales';
import 'rxjs/add/operator/takeWhile';
import { LoginService } from 'app/services/login.service';


import { CommonDataService } from 'app/services/common-data.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {
    constructor(private readonly loginService: LoginService, private readonly commonData: CommonDataService, private readonly translateService: TranslateService, private readonly router: Router, private renderer: Renderer2) {
        this.focusIdx = 0;
        this.buttonsActive = [];
    }

    private destroyed: boolean;

    private siteAddress: string;

    public focusIdx: number;

    public buttonsActive: boolean [];

    public firstActive: boolean;

    ngOnInit(): void {
        this.translateService.setDefaultLang('en');


        let localeConfigured = false;
        this.router.events.takeWhile(() => !this.destroyed && !localeConfigured).subscribe(e => {
            if (!(e instanceof ActivationStart))
                return;

            var event = e as ActivationStart;
            const locale = event.snapshot.queryParams['culture'] || this.commonData.language || this.translateService.getBrowserLang() || 'en';
            this.translateService.use(locale);
            sessionStorage.setItem('userLocale', locale);
            moment.locale(locale);
            numeral.locale(locale === 'uk' ? 'uk-ua' : locale);

            localeConfigured = true;
        });

        new IntervalObservable(1000).takeWhile(() => !this.destroyed)
            .subscribe(() => $('.tooltip.show').filter((i: number, t: HTMLElement) => $(`[data-toggle=tooltip][aria-describedby="${t.id}"]`).length === 0).remove());

        this.loginService.getSiteAddress().subscribe(data => {
                if (!data || !data.success) {
                    this.commonData.showLoadingImg = false;
                    this.commonData.showErrors(['Reload page Please'])
                }
                this.commonData.showLoadingImg = false;
                this.siteAddress = data.siteAddress;
            },
            e => {
                this.commonData.showErrors([e.message || e]);

                this.commonData.showLoadingImg = false;
            });

    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    ngAfterViewChecked(): void {
        if (this.commonData.popupActive && this.firstActive)
            return;
        else if (!this.commonData.popupActive && this.firstActive)
            setTimeout(() => {
                this.firstActive = false;
            },1);


        if (this.commonData.popupActive && !this.firstActive) {
            setTimeout(() => {
                this.firstActive = true;

                if (this.commonData.dialogType !== 'Question') this.buttonsActive[0] = true;
                if (this.commonData.dialogType === 'Question' && this.commonData.dialogOnYes) this.buttonsActive[1] = true;
                if (this.commonData.dialogType === 'Question' && this.commonData.dialogOnNo) this.buttonsActive[2] = true;
                if (this.commonData.dialogType === 'Question' && this.commonData.dialogOnCancel) this.buttonsActive[3] = true;

                this.buttonsActive.forEach((item, i) => {
                    if (item) this.focusIdx = i;
                });
            },1)

        }
    }

    @HostListener('window:message', ['$event']) onMessage(e: MessageEvent) {
        if (e.origin === 'http://' + this.siteAddress || e.origin === 'https://' + this.siteAddress ) {
            if (e.data === 'close'){
                setTimeout(() =>{ this.logoOut() }, 50);
            }
        }
    }

    private handleKeyEvent = (event: KeyboardEvent): void => {
        if (!this.commonData.popupActive) return;

        let focusIdx = this.focusIdx;

        if (event.keyCode === 39 && focusIdx < 3) {
            if (this.buttonsActive[focusIdx + 1]) this.focusIdx = ++focusIdx;
            else {
                while (focusIdx < 3) {
                    focusIdx++;
                    if (this.buttonsActive[focusIdx + 1]) {
                        this.focusIdx = ++focusIdx;
                        break
                    }
                }
            }
        } else if (event.keyCode === 37 && focusIdx > 0){
            if (this.buttonsActive[focusIdx - 1]) this.focusIdx = --focusIdx;
            else {
                while (focusIdx > 0) {
                    focusIdx--;
                    if (this.buttonsActive[focusIdx - 1]) {
                        this.focusIdx = --focusIdx;
                        break
                    }
                }
            }
        }
    };

    private onDialogButtonPress = (action: () => void) => {
        if (action)
            setTimeout(action, 1);
    };

    public logoOut = (): boolean => {
        this.loginService.logout().subscribe(data => {
            if (data.success)
                window.location.reload();
        }, e => this.commonData.showErrors([e.message || e]));

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/app/app.component.ts